/**
 * Vuex 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局加载状态
    loading: false,

    // 用户信息
    userInfo: null
  },

  mutations: {
    // 设置加载状态
    SET_LOADING(state, loading) {
      state.loading = loading
    },

    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    }
  },

  actions: {
    // 设置加载状态
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },

    // 设置用户信息
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    }
  },

  getters: {
    loading: (state) => state.loading,
    userInfo: (state) => state.userInfo
  }
})
